<section class="overflow-auto custom-scrollbar" *ngIf="!isPlansLoading">
    <div *ngIf="!isSingleAppPurchase" class="bg-whitsmoke mb-xxl-2 pt-1 d-flex set-background overflow-auto">
        <div class="container text-center do-heading">
            <!-- <div class="text-center">
                <h4 class="mb-15 wow fw-bold" data-wow-delay=".2s">Find the right product for your business</h4>
            </div> -->
            <div class="tab-container" role="tablist" aria-label="Available apps">
                @for(item of availableApps; track item.type){
                <button type="button" role="tab" class="tab"
                    [class.active]="subscriptionState.selectedApp | fn : isAppSelected : item.type"
                    [attr.aria-selected]="subscriptionState.selectedApp | fn : isAppSelected : item.type"
                    (click)="selectProduct(item.type)">
                    {{item.name}}
                </button>
                }
            </div>
        </div>
    </div>
    <div class="container plans w-100 mb-5 pt-1">
        @if(selectedProduct === productType.Sketch){
        <div class="d-flex flex-column gap-">
            <!-- <p>Get your project generated in the CAD software you already use. We’ll give you a backup file so you can jump straight in and turn it into your customer-specific drawing</p> -->
            <div *ngIf="!hideCadSoftwareSelection" class="export-card">
                <span class="export-card-label">Build in Sketch</span>
                <div class="software-switcher d-flex align-items-center"
                    role="tablist" aria-label="CAD software">
                    @for(software of cadSoftwares; track software.cadSoftwareId){
                    <button type="button" role="tab"
                        class="tab tab-custom flex-column align-items-center justify-content-center"
                        [class.active]="selectedSketchSoftware === software.cadSoftwareId"
                        [attr.aria-selected]="selectedSketchSoftware === software.cadSoftwareId"
                        (click)="switchCadSoftware(software.cadSoftwareId)">
                        <span class="tab-prefix">Export to</span>
                        <!-- cadSoftwareName already holds the full name ("EPLAN" / "SEE Electrical" /
                             "PC Schematic"), so unlike the website we don't need its name/subName split. -->
                        <span class="tab-main">{{software.cadSoftwareName}} Software</span>
                    </button>
                    }
                </div>
            </div>
            <div class="roww d-flex flex-column flex-md-row align-items-center mvv mt-4">
                <div class="col-lg-3 px-2 position-relative pt-80">
                    <app-selected-app-description
                        class="bg-whitee p-3 d-flex rounded"
                        [showBulletPoints]="false"
                        [showDescription]="true"
                        [highlight]="true"
                        [selectedApp]="subscriptionState.selectedApp">
                    </app-selected-app-description>
                </div>
                <div class="col-lg-9 px-2">
                    <app-plan-selector
                        [availablePlans]="allPlans"
                        [subscriptionState]="subscriptionState"
                        [selectedProduct]="subscriptionState.selectedApp"
                        (subscriptionStateChanged)="subscriptionStateChanged($event)"
                        [selectedCountryCurrency]="selectedCurrency"
                        [subscriptionBillingCycle]="selectedBillingCycle"
                        (onBillingCycleChanged)="onBillingCycleChanged($event)"
                        [width]="'100%'"
                        [mode]="'new-organization'"
                        (saveTriggered)="goForward.emit()">
                    </app-plan-selector>
                </div>
            </div>
        </div>
        }@else{
        <div class="roww flex-column flex-md-row d-flex align-items-center mvv mt-4">
            <div class="col-lg-3 px-2 position-relative pt-80">
                <app-selected-app-description 
                    class="bg-whitee p-3 d-flex rounded"
                    [showBulletPoints]="false"
                    [showDescription]="true"
                    [highlight]="true"
                    [selectedApp]="subscriptionState.selectedApp">
                </app-selected-app-description>
            </div>
            <div class="col-lg-9 px-2">
                @if(selectedProduct === productType.DrawoutApp || selectedProduct === productType.LegacyZen){
                <!-- <app-contact-form
                            [choosenProduct]="selectedProduct">
                        </app-contact-form> -->
                }@else {
                    <app-plan-selector
                        [availablePlans]="allPlans"
                        [subscriptionState]="subscriptionState"
                        [selectedProduct]="subscriptionState.selectedApp"
                        (subscriptionStateChanged)="subscriptionStateChanged($event)"
                        [selectedCountryCurrency]="selectedCurrency"
                        [subscriptionBillingCycle]="selectedBillingCycle"
                        (onBillingCycleChanged)="onBillingCycleChanged($event)"
                        [width]="'100%'"
                        [mode]="'new-organization'"
                        (saveTriggered)="goForward.emit()">
                    </app-plan-selector>
                }
            </div>
        </div>
        }
    </div>
</section>
<div *ngIf="isPlansLoading" class="w-100 h-100 d-flex justify-content-center align-items-center">
    <mat-spinner [diameter]="50"></mat-spinner>
</div>